import { IReduxAction } from '../../../services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  SET_LOADING_SEND,
  GET_ALL_SUCCESS,
  GET_BY_ID_SUCCESS,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ORDER,
  SET_ORDERBY,
  SEARCH,
  SET_LOADING_SELECTS,
  GET_ALL_SELECTS_SUCCESS
} from './daily-route-constants';

const INITIAL_STATE: any = {
  loadingData: true,
  loadingSend: false,
  loadingSelects: true,
  form: {
    data: null,
    errors: [],
    selects: null
  },
  list: {
    allRows: [],
    rows: [],
    rowsCount: 0,
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    selects: {},
    order: 'desc',
    orderBy: 'createdAt'
  }
};

const dailyRouterReducer = (state = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case SET_LOADING_SEND: {
      return {
        ...state,
        loadingSend: action.loading
      };
    }

    case SET_LOADING_SELECTS: {
      return {
        ...state,
        loadingSelects: action.loading
      };
    }

    case GET_ALL_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: [...action.payload.rows],
          allRows: [...action.payload.rows],
          rowsCount: action.payload.rowsCount ?? state?.list?.rowsCount
        }
      };
    }

    case SEARCH: {
      const { queryText } = action;

      const results =
        queryText !== ''
          ? state.list.allRows.filter(
              (item: any) =>
                item.userName.toLowerCase().startsWith(queryText.toLowerCase()) ||
                item.userName.toLowerCase().includes(queryText.toLowerCase()) ||
                item.userExternalCode.toLowerCase().includes(queryText.toLowerCase()) ||
                item.userExternalCode.toLowerCase().includes(queryText.toLowerCase())
            )
          : state.list.allRows;

      return {
        ...state,
        list: {
          ...state.list,
          rows: [...results]
        }
      };
    }

    case GET_BY_ID_SUCCESS: {
      return {
        ...state,
        form: {
          ...action.payload,
          selects: {
            ...state.form.selects,
            ...action.payload.selects
          }
        }
      };
    }

    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ORDER: {
      return {
        ...state,
        list: {
          ...state.list,
          order: action.order
        }
      };
    }

    case SET_ORDERBY: {
      return {
        ...state,
        list: {
          ...state.list,
          orderBy: action.orderBy
        }
      };
    }

    case GET_ALL_SELECTS_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          selects: {
            ...state.list.selects,
            sellers: action.payload?.selects?.sellers
          }
        }
      };
    }

    default:
      return state;
  }
};

export default dailyRouterReducer;
